export const lightItalicTextInsideBrackets = (string: string) => {
  if (!string) return string

  return (
    <span
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: string.replace(/\(.*?\)/g, (replaceStr: string) => `<em style='font-weight: 300;'>${replaceStr}</em>\n`)
      }}
    />
  )
}
